"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.joinPathSegments = void 0;
var PATH_SEGMENT_DIVIDER = '/';
/**
 * Joins path segments and ensures that there are no duplicated double slashes between them
 */ var joinPathSegments = function() {
    for(var _len = arguments.length, pathnames = new Array(_len), _key = 0; _key < _len; _key++){
        pathnames[_key] = arguments[_key];
    }
    return pathnames.filter(Boolean).join(PATH_SEGMENT_DIVIDER).replaceAll(/\/+/g, PATH_SEGMENT_DIVIDER)// Siple preserve of protocols as double slashes were deleted previously
    .replace('https:/', 'https://').replace('http:/', 'http://');
};
exports.joinPathSegments = joinPathSegments; //# sourceMappingURL=joinPathSegments.js.map
